
export default {
  state: {
    
    dataInfoCita  : null,
    dataSeguro    : null,
    dataTitulares : null,
    
    dataDocumentos: {
      personas: null,
      cita: null
    },

    dataEnvioImagenes    : null,
    dataEnvioLaboratorios: null,
    dataEnvioLabs400     : null,
    dataEnvioProcesos    : null
  },

  mutations: {

    resetStateRegistrarCita(state){
      state.dataCita = null;
      state.dataSeguro = null;
      state.dataTitulares = null;

      state.dataDocumentos = {
        personas: null,
        cita: null
      }

      state.dataEnvioImagenes     = null;
      state.dataEnvioLaboratorios = null;
      state.dataEnvioLabs400      = null;
      state.dataEnvioProcesos     = null;
    },

    setDataInfoCita(state, newData){
      state.dataInfoCita = newData
    },

    setDataSeguro(state, newData){
      state.dataSeguro = newData
    },

    setDataTitulares(state, newData){
      state.dataTitulares = newData
    },

    setDataDocsPersonas(state, newData){
      state.dataDocumentos.personas = newData
    },

    setDataDocsCita(state, newData){
      state.dataDocumentos.cita = newData
    },

    setDataEnvioImagenes(state, newData){
      state.dataEnvioImagenes = newData
    },

    setDataEnvioLaboratorios(state, newData){
      state.dataEnvioLaboratorios = newData
    },

    setDataEnvioLabs400(state, newData){
      state.dataEnvioLabs400 = newData
    },

    setDataEnvioProcesos(state, newData){
      state.dataEnvioProcesos = newData
    },

  },
  
};